export class PersonalAuthResponse {
    id: number;
    requestNumber?: string;
    response_number?: string;
    auth_type?: string;
    customerName?: string;
    birthDate?: Date;
    gender?: string;
    mobileNumber?: string;
    mobileCompany?: string;
    errorCode?: string;
    returnCode?: number;
    authDate?: Date;
}
